import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ConstructionCard from './ConstructionCard';
import TableauChart from './Charts/TableauChart';
import { formatClassName, toggleElementFullscreen } from '../Util';
import i18n from '../../src/i18n/translate';

const ReportCard = props => {
  const { showViewMore, viewMoreUrl, chartContext, tableau, relatedChartId, showReportToolbar, viewMoreLabel, filters } = props;
  const embedReportDiv = useRef(null);

  const getButtonConfig = () => {
    if (!showViewMore) return null;

    const chartDiv = embedReportDiv.current ? embedReportDiv.current.children[0] : null;
    
    let button = {
      label: viewMoreLabel || i18n.t('View Report'),
      style: 'link',
      data: { action: 'action-dash-view-report', objectId: relatedChartId, objectType: 'chart' }
    };

    if (viewMoreUrl) {

      button.action = () => { window.location.href = viewMoreUrl };
    } else {
      button.action = () => toggleElementFullscreen(chartDiv);
    }

    return [button];
  }

  return (
    <ConstructionCard 
      {...props} 
      className={formatClassName(['report-card', props.className])}
      buttonConfig={getButtonConfig()}
      alwaysExpanded={true}
    >
      <div className="embed-report" ref={embedReportDiv}>
        <TableauChart 
          tableau={tableau}
          chart={chartContext.chart}
          chartSourceUrl={chartContext.iframe_src}
          showReportToolbar={showReportToolbar}
          filters={filters}
        />
      </div>
    </ConstructionCard>
  );
}

ReportCard.propTypes = {
  chartContext: PropTypes.shape({
    chart: PropTypes.object.isRequired,
    iframe_src: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string,
  filters: PropTypes.object,
  relatedChartId: PropTypes.string,
  showReportToolbar: PropTypes.bool,
  showViewMore: PropTypes.bool,
  size: PropTypes.string,
  tableau: PropTypes.object,
  title: PropTypes.string.isRequired,
  viewMoreLabel: PropTypes.string,
  viewMoreUrl: PropTypes.string
};

ReportCard.defaultProps = {
  showReportToolbar: false,
  showViewMore: false,
  size: 'narrow',
  tableau: window.tableau,
  titleSize: 18
};

export default ReportCard;
